import VueYouTube from 'vue-youtube';
import Vue from 'vue';

Vue.use(VueYouTube);
